/**
 * Application constants.
 * Constants can be added here to to environment variables.
 * Constants should be added to environment variables if they are different for local, dev, and or prod.
 */
export const CONSTANTS = {
  LINK_TO_DEMO_FOR_PROFESSIONALS: 'https://calendly.com/d/cxpz-wnr-7sw/conrad-for-pros-demo',
  LINK_TO_DEMO_FOR_ENTERPRISES: 'https://calendly.com/d/cxf8-h9b-c6w/conrad-enterprise-demo',
}
